export default __webpack_public_path__ + "static/JJ_IM_Logo_SingleLine_White_RGB-829446024a38cdbaef78c31b754effdb.svg";